import { endpoint } from '../decorators';
import { BaseViewModel } from './base-view-model';

@endpoint('Count')
export class CorrCountViewModel extends BaseViewModel {
  Count: number = null;
}
